// modules
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

// aliased
import Link from 'components/Link';

// local
import styles from './ProfileMain.pcss';
import Scroll from '../Scroll';

const iAmA = [
  'tech leader',
  'software engineer',
  'web enthusiast',
  'passionate maker',
  'full-stack js addict',
];

export default class ProfileMain extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
  }
  static defaultProps = {}

  render() {
    const { className } = this.props;
    const classNames = classnames(className, styles.profileMain);
    return (
      <div className={ classNames }>
        <div className={ styles.avatar } />
        
        <div className={ styles.copy }>
          <p className={ styles.name }>{ 'colby dauphinais' }</p>
          <div className={ styles.title }>
            <span style={{ marginRight: '4px' }}>{ 'I am a ' }</span>
            <Scroll className={ styles.iama } items={ iAmA } />
          </div>
          
          <Link to={ 'mailto:colby@dauphina.is' } className={ styles.email }>
            { 'colby@dauphina.is' }
          </Link>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeView/ProfileMain/index.jsx